import { Component } from '@angular/core';
import { TagComponent } from "@shared/components/commons/tag/tag.component";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { UserRecord } from "@models/organisations/user-record";
import { Tag } from "@models/common/tag";

type CellRendererParams = ICellRendererParams<UserRecord> & {
  roleClick?: (role: string) => void
}

const colorRoleDictionary: Record<string, string> = {
  Admin: '#35A37F',
  Manager: '#2E8DB7',
  Preparer: '#6D6FD4',
  User: '#8E6CDA',
  Invitation: '#CB872F'
}

@Component({
  selector: 'app-ag-user-roles',
  standalone: true,
  imports: [TagComponent],
  templateUrl: 'ag-user-roles.component.html',
  styleUrl: 'ag-user-roles.component.scss'
})
export class AgUserRolesComponent implements ICellRendererAngularComp {
  params!: CellRendererParams;
  roles: Tag[] = [];
  isUserInvitation: boolean = false;
  invitationTag: Tag = new Tag({
    customColor: colorRoleDictionary['Invitation'],
    name: 'Invitation Pending',
    tagId: 'Invitation Pending'
  });

  agInit(params: CellRendererParams): void {
    this.params = params;
    this.fillRoles();
    this.checkIsUserInvitation();
  }

  refresh(params: CellRendererParams): boolean {
    this.params = params;
    this.fillRoles();
    this.checkIsUserInvitation();

    return true;
  }

  handleRoleClick(role: Tag): void {
    this.params.roleClick?.(role.name);
  }

  private checkIsUserInvitation(){
    this.isUserInvitation = 'userInvitationId' in this.params.data!;
  }

  private fillRoles(): void {
    this.roles = this.params.data?.roles?.map((role) => new Tag({
      customColor: colorRoleDictionary[role] || '',
      name: role,
      tagId: role
    })) ?? [];
  }
}
